// extracted by mini-css-extract-plugin
module.exports = {"quote":"component-module--quote--1_VpW","container":"component-module--container--2WnyM"};